module.exports = __webpack_public_path__ + "assets/img/kv-3c89ed3e.png";